import { COLORS } from '../../constant/colors';

interface DateStatusHeaderProps {
  displayStatus: 'SHOWING' | 'ENDED' | 'NOT_STARTED' | undefined;
  dayDifference: number;
}

const StatusHeader = ({
  displayStatus,
  dayDifference,
}: DateStatusHeaderProps) => {
  const statusConfig = {
    SHOWING: {
      backgroundColor: COLORS.BlueMatte,
      message:
        dayDifference === 0
          ? 'Finishing Today...'
          : `Finishing in ${dayDifference} days`,
    },
    NOT_STARTED: {
      backgroundColor: COLORS.GreenMatte,
      message:
        dayDifference === 0
          ? 'Starting Today...'
          : `Displaying in ${dayDifference} days`,
    },
    ENDED: {
      backgroundColor: COLORS.RedMatte,
      message:
        dayDifference === 0
          ? 'Finished Today...'
          : `Finished ${dayDifference} days ago`,
    },
  };

  const { backgroundColor, message } =
    statusConfig[(displayStatus || '') as keyof typeof statusConfig];

  if (!message) return null;

  return (
    <div
      style={{ background: backgroundColor }}
      className="text-white p-2 text-center uppercase text-xl font-bold"
    >
      {message}
    </div>
  );
};

export default StatusHeader;
